// ID 转统一格式
import type Api from '@/types/api'
import * as ISchemaStore from './data.d'
import { mapReportStatus, ReportInfoID } from '@/constants/export.constant'

// #region 导出报告相关
export function transformFetchReportListID(
  response: Api.IResponse<{
    taskList: ReportInfoID[]
    totalNum: number
  }>,
): ISchemaStore.IReportListResponse {
  const { data } = response
  return {
    ...data,
    taskList: data.taskList.map((task) => ({
      ...task,
      taskStatus: mapReportStatus(task.taskStatus),
    })),
  }
}

// #endregion 导出报告相关
